module.exports = __webpack_public_path__ + "img/experience-1-image.28167135.jpg";